
import { defineComponent, onMounted, inject } from "vue";

import { updateActiveLinkOnScroll } from "@/components/FixedNav/animate";
import { ActiveLinkContext } from "@/interfaces/nav";
import SectionHeader from "@/components/Shared/SectionHeader/SectionHeader.vue";
import ActionButton from "@/components/Shared/ActionButton/ActionButton.vue";
import Highlight from "@/components/AboutMe/Highlight/Highlight.vue";
import Highlights from "@/fixtures/highlights";
import animate from "@/components/AboutMe/animate";

export default defineComponent({
  name: "AboutMe",
  components: {
    SectionHeader,
    ActionButton,
    Highlight,
  },
  setup() {
    const { updateActiveLink } = inject("active-link") as ActiveLinkContext;

    onMounted(() => {
      updateActiveLinkOnScroll("#about-me", updateActiveLink);
      animate();
    });

    return {
      Highlights,
    };
  },
});
